import {
	GET_BRANDS_DATA,
	GET_BRANDS_DATA_SUCCESS,
	GET_BRANDS_DATA_FAILURE,
	GET_MODELS_DATA,
	GET_MODELS_DATA_SUCCESS,
	GET_MODELS_DATA_FAILURE,
	GET_VARIANTS_DATA,
	GET_VARIANTS_DATA_SUCCESS,
	GET_VARIANTS_DATA_FAILURE,
	GET_DOCUMENT_TEMPLATE,
	GET_DOCUMENT_TEMPLATE_SUCCESS,
	GET_DOCUMENT_TEMPLATE_FAILURE,
	DELETE_VARIANTS_DATA,
} from "../Types/addVehicles";
import { CALL_API } from "../api.middleware";
import { LOGOUT_SUCCESS } from "../Types";
import { CLIENT_NAME } from "../../constants";

export const getBrandsData = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/catalog/vehicle/makes?clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [GET_BRANDS_DATA, GET_BRANDS_DATA_SUCCESS, GET_BRANDS_DATA_FAILURE],
				showLoader: true,
				showToast: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Vehicle - 32", error);
	}
};

export const getModelsData =
	(params = {}) =>
	async (dispatch) => {
		try {
			await dispatch({
				[CALL_API]: {
					url: "/catalog/vehicles/models",
					method: "GET",
					types: [GET_MODELS_DATA, GET_MODELS_DATA_SUCCESS, GET_MODELS_DATA_FAILURE],
					params,
					showLoader: true,
					showToast: true,
				},
			});
		} catch (error) {
			// alert(`${error}`);
			console.error("Vehicle - 52", error);
		}
	};

export const getVariantsData =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: "/catalog/vehicle/variants",
					method: "GET",
					types: [
						GET_VARIANTS_DATA,
						GET_VARIANTS_DATA_SUCCESS,
						GET_VARIANTS_DATA_FAILURE,
					],
					params,
					showLoader: true,
					showToast: true,
				},
			});
		} catch (error) {
			// alert(`${error}`);
			console.error("Vehicle - 72", error);
		}
	};

export const documentTemplate = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/settings/document-templates?clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [
					GET_DOCUMENT_TEMPLATE,
					GET_DOCUMENT_TEMPLATE_SUCCESS,
					GET_DOCUMENT_TEMPLATE_FAILURE,
				],
				showLoader: true,
				showToast: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Vehicle - 93", error);
	}
};

export const deleteVariantsData = () => {
	return {
		type: DELETE_VARIANTS_DATA,
	};
};

export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}
